export default __webpack_public_path__ + "static/media/mt_ln_1.152ce180.png";